<template>
  <section class="section-cta">
    <div class="container text-center">
      <h2 class="cta-title fade-in-up">まずはLINE友だち登録から！</h2>
      <p class="cta-subtitle fade-in-up delay-1">今すぐメニューをチェック。</p>
      <div class="row justify-content-center mt-4">
        <div class="col-auto fade-in-up delay-2">
          <!-- QRコード（環境変数で画像を切り替え） -->
          <div class="qr-card">
            <img :src="qrCodeSrc" alt="LINE QRコード" class="qr-img">
          </div>
        </div>
      </div>
      <!-- LINE友だち登録ボタン -->
      <div class="mt-4 fade-in-up delay-3">
        <a :href="lineUrl" target="_blank" rel="noopener noreferrer" class="btn-line">
          <i class="bi bi-chat-fill"></i>
          LINE友だち登録
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionCta',
  data() {
    return {
      // 環境ごとのLINE友だち登録URL
      lineUrls: {
        local: 'https://line.me/R/ti/p/@373owvvz',
        develop: 'https://line.me/R/ti/p/@235auhvr#~',
        production: 'https://line.me/R/ti/p/@310inlgc#~',
      },
    };
  },
  computed: {
    qrCodeSrc() {
      const env = process.env.NODE_ENV || 'local';
      return `/img/line/${env}.png`;
    },
    lineUrl() {
      const env = process.env.NODE_ENV || 'local';
      return this.lineUrls[env] || this.lineUrls.local;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.section-cta {
  padding: $section-padding-y 0;
  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 50%, #e0f2f1 100%);

  @include media-down(768px) {
    padding: $section-padding-y-sm 0;
  }
}

.cta-title {
  font-size: $font-size-section-title;
  font-weight: 700;
  color: $color-text;
  margin-bottom: 0.5rem;
}

.cta-subtitle {
  font-size: $font-size-section-subtitle;
  color: $color-text-light;
}

.qr-card {
  background-color: #fff;
  border-radius: $border-radius-lg;
  padding: 1.5rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  display: inline-block;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }
}

.qr-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border-radius: $border-radius-base;
}

.btn-line {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: $color-line;
  color: #fff;
  padding: 0.875rem 2.5rem;
  border-radius: 50px;
  font-size: $font-size-section-subtitle;
  font-weight: 700;
  text-decoration: none;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 12px rgba($color-line, 0.3);

  &:hover {
    background-color: $color-line-dark;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba($color-line, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  i {
    font-size: 1.25rem;
  }
}
</style>
